// --------------------------------------------------------------------------
// #230 Donation Tabs Query String - Used when the block appears on a landing page
//                                   to pass the users selection to the donation page
// --------------------------------------------------------------------------
// Author:      Alix Richards
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2017, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
  var ref = { $root: options.context };
  var state = { monthly: null, optionNumber: null, amount: null };

  function createQueryString() {
    /// Create the querystring
    var queryString;
    queryString = '?ismonthly=' + state.monthly + '&option=' + state.optionNumber;
    /// Custom donation amount, different queryString
    if (state.optionNumber === '4') {
      queryString += '&amount=' + state.amount;
    }
    /// Find the button href, create/update the url and go to donation page
    var buttonUrl = ref.$root.find('[data-name="donation-cta-button"]').attr('href');
    var updatedUrl = buttonUrl + queryString;
    window.location.href = updatedUrl;
  }

  function init() {
    /// Events
    ref.$root.on('click', '[data-name="donation-cta-button"]', function (event) {
      /// When CTA is clicked - lets make a querystring
      event.preventDefault();
      /// Reset the querystring
      state.monthly = null;
      state.optionNumber = null;
      state.amount = null;
      /// Find the new query options
      /// Find state.monthly
      var $selectedTab = ref.$root.find('[data-binding="donation-tabs"]').filter('.active');
      state.monthly = !!$selectedTab.length && $selectedTab.attr('data-state') === 'monthly';

      /// Find state.optionNumber
      var userSelection = ref.$root.find('[data-name="donation-radio"]:checked');
      if (!!userSelection.length) {
        /// find the id number
        state.optionNumber = userSelection.attr('id').replace(/^\D+/g, '');
        /// Find state.amount
        if (userSelection.attr('id').replace(/^\D+/g, '') === '4') {
          state.amount = $selectedTab.find('[data-name="personalised-donation"]').val();
        }
      } else {
        state.optionNumber = '0';
      }
      createQueryString();
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/donation-tabs-querystring.js
// module id = 279
// module chunks = 0